<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-hover v-slot="{ hover }">
          <v-btn
            block
            height="80"
            class="success mr-1"
            :elevation="hover ? 8 : 2"
            v-on="{ ...tooltip }"
            :disabled="acceptAssignmentDisabled"
            @click="openDialog"
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-account-check</v-icon>
              <span class="action-text">Accept Assignment</span>
            </div>
          </v-btn>
        </v-hover>
      </template>
      <span>ACCEPT ASSIGNMENT</span>
    </v-tooltip>

    <v-dialog persistent v-model="dialog" max-width="500px">
      <template v-if="editedCasefile">
        <v-card class="text-center">
          <v-card-title class="justify-center text-h5 grey lighten-2">
            ACCEPT ASSIGNMENT?
          </v-card-title>
          <v-card-text class="mt-3 pa-0">
            CASEFILE NUMBER: AA
            <span v-if="filteredDept.length">
              /{{ filteredDept[0].name }}
              <span v-if="filteredSubRefTypes.length">
                /{{ filteredSubRefTypes[0].subCode }}
              </span>
            </span>
            /{{ editedCasefile.id }}/{{ yearOnly(editedCasefile.createdAt) }}
            <span v-if="filteredBranch.length">
              /{{ filteredBranch[0].brCode }}
            </span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile small dark class="mt-3 mr-2 error" @click="closeDialog">
              Cancel
            </v-btn>
            <v-btn
              tile
              small
              class="mt-3 mr-2 success"
              @click="acceptAssignment"
            >
              OK
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import moment from "moment";

export default {
  name: "acceptAssignment",
  props: {
    casefile: { type: Object, required: true },
    refType: Array,
    branches: Array,
    subRefTypes: Array,
    insurer: Array,
    members: Array,
    handlers: Array,
    states: Array,
  },
  data() {
    return {
      dialog: false,
      editedCasefile: null, // Local copy for editing
    };
  },
  computed: {
    acceptAssignmentDisabled() {
      return !(
        this.casefile.fileStatus === "ADAC" &&
        this.casefile.adjuster === this.$store.state.auth.user.id
      );
    },
    filteredDept() {
      return this.refType
        .filter((d) => d.id === this.editedCasefile?.refType)
        .map((d) => ({
          ...d,
          name: d.name ? d.name.trim().toUpperCase() : "",
        }));
    },
    filteredSubRefTypes() {
      return this.subRefTypes
        .filter((sub) => sub.id === this.editedCasefile?.subRefType)
        .map((sub) => ({
          ...sub,
          subCode: sub.subCode ? sub.subCode.trim().toUpperCase() : "",
        }));
    },
    filteredBranch() {
      return this.branches
        .filter((b) => b.id === this.editedCasefile?.branch)
        .map((b) => ({
          ...b,
          name: b.name ? b.name.trim().toUpperCase() : "",
        }));
    },
  },
  methods: {
    openDialog() {
      // Clone casefile for local editing
      this.editedCasefile = JSON.parse(JSON.stringify(this.casefile));
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.editedCasefile = null;
    },
    acceptAssignment() {
      // Use editedCasefile for submission
      const payload = {
        ...this.editedCasefile,
        fileStatus: "INVE",
        dateStartInv: moment().format(),
      };
      CasefileDataService.update(this.editedCasefile.id, payload)
        .then((response) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "green",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
          // Update global casefile only after success
          Object.assign(this.casefile, payload);
          this.$emit("accepted");
        })
        .catch((e) => {
          console.log(e);
        });
      this.closeDialog();
    },
    yearOnly(value) {
      return moment(value).format("YY");
    },
  },
};
</script>
<style scoped>
.action-text {
  font-size: 0.9rem;
  white-space: normal;
  text-align: center;
  line-height: 1.2;
}
</style>
